import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const $ = jQuery;

$( () => {
    $('a[href$=".jpg"], a[href$=".png"]')
        .addClass('zoom-img')
        .each(function () {
            var t = $(this);
            t.attr('title', t.children('img').attr('title'));
        });

    Fancybox.bind('a.zoom-img', {
        nextEffect: 'fade',
        prevEffect: 'fade',

        padding: 0,
        margin: 25,

        helpers: {
            overlay: {
                opacity: 0.5,
                locked: false
            },
            title: {
                type: 'inside'
            }
        }
    });

    Fancybox.bind( '[data-fancybox]', {
        nextEffect: 'fade',
        prevEffect: 'fade',

        padding: 0,
        margin: 25,

        helpers: {
            overlay: {
                opacity: 0.5,
                locked: false
            },
            title: {
                type: 'inside'
            }
        }
    });

    Fancybox.bind('a.lightbox-video, .lightbox-video a', {
        padding: 0,
        margin: 25,

        helpers: {
            overlay: {
                opacity: 0.5,
                locked: false
            },
            title: {
                type: 'inside'
            }
        }
    });

} );